
import Api from './api'

export default {

    tag: function (tag, email) {

        return Api.post(`/user/tag/${ tag }/email/${ email }`)

    }

}
